import { useEffect, useRef } from 'react';
import { Capacitor } from '@capacitor/core';
import { ScreenOrientation } from '@capacitor/screen-orientation';

export default function useGameScreen() {
  const wakeLock = useRef(null);

  useEffect(() => {
    // 1. Wake Lock
    const requestWakeLock = async () => {
      try {
        if ('wakeLock' in navigator) {
          wakeLock.current = await navigator.wakeLock.request('screen');
        }
      } catch (e) {}
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') requestWakeLock();
    };

    requestWakeLock();
    document.addEventListener('visibilitychange', onVisibilityChange);

    // 2. Forzar landscape
    const lockLandscape = async () => {
      if (Capacitor.isNativePlatform()) {
        try {
          await ScreenOrientation.lock({ orientation: 'landscape' });
        } catch (e) {}
      } else {
        try {
          if (screen.orientation?.lock) await screen.orientation.lock('landscape');
        } catch (e) {}
      }
    };

    lockLandscape();

    return () => {
      if (wakeLock.current) {
        wakeLock.current.release().catch(() => {});
        wakeLock.current = null;
      }
      document.removeEventListener('visibilitychange', onVisibilityChange);

      // Volver a portrait al salir del juego
      const unlockOrientation = async () => {
        if (Capacitor.isNativePlatform()) {
          try {
            await ScreenOrientation.lock({ orientation: 'portrait' });
          } catch (e) {}
        } else {
          try {
            if (screen.orientation?.unlock) screen.orientation.unlock();
            if (document.fullscreenElement) document.exitFullscreen();
          } catch (e) {}
        }
      };
      unlockOrientation();
    };
  }, []);
}
